<template>
		<div class="container-fluid">
			<img :src="mnbg" alt="Imagen de fondo" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;object-fit: cover;opacity: 0.05;z-index: -1;">
			<div class="row d-flex align-items-end"
			style="background: linear-gradient(to top, #000000, #ffffffcc), url(${magdamn}); ">
				<div class="col-12" :style="{'background-image': `url(${magdamn1})`, backgroundSize: 'cover', backgroundPosition: 'center'}" style="box-shadow: rgba(0, 0, 0, 0.67) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.85) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.4) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.4) 0px 4px 2px, rgba(0, 0, 0, 0.18) 0px 8px 4px, rgba(0, 0, 0, 0.18) 0px 16px 8px, rgba(0, 0, 0, 0.18) 0px 32px 16px, rgba(0, 0, 0, 0.18) 0px 64px 32px;">
					<div class="row">
						<div class="p-5" style="margin-top:300px" data-aos="flip-left">
							<p class="description-md text-white epilogue-bold">
								Mexicanos al Grito de Ayuda, A.C.
							</p>
							<a class="btn btn-primary m-0 rounded-pill" href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA" target="_blank">
								<p class="m-0 epilogue-bold">
									Saber más
								</p>
							</a>
						</div>
					</div>
					<div class="row text-white m-5 p-0" data-aos="flip-left">
						<Carousel :wrap-around="true" :autoplay="2500" :breakpoints="breakpoints" class="col-12 m-0 p-0">
							<Slide v-for="(card_mn, index) in cards_mn" :key="index" class="d-flex">
							<img :src="card_mn.image" class="m-2 img-fluid" alt="" style="max-width: 60px;"/>
								<div class="d-flex flex-column" style="text-shadow: 1px 1px 2px black;">
									<p class="description-xxs epilogue-semibold">{{card_mn.title}}</p>
									<p class="m-0 epilogue-regular description-xxxs">
										{{card_mn.text}}
									</p>
								</div>
							</Slide>
						</Carousel>
					</div>
				</div>
			</div>
			<div>
			<div class="row mt-3" data-aos="flip-left">
				<div class="col-12">
					<div class="m-4 text-center">
						<h2 class="description-md epilogue-bold">Nuestra misión</h2>
						<h3 class="description-sm epilogue-regular">
							Somos una asociación civil con el objetivo de promover, difundir artes escénicas, música, audiovisuales con lenguaje cinematográfico entre otras disciplinas en espacios públicos y espacios no convencionales						</h3>
					</div>
				</div>
			</div>
			<div class="row m-md-5 m-2" data-aos="flip-left">
				<div class="column">
					<img :src="a1">
					<img :src="a2">

				</div>
				<div class="column">
					<img :src="b1">
				</div>
				<div class="column">
					<img :src="c1">
					<img :src="c2">
				</div>
			</div>

			<!-- <div class="row p-md-5 p-2">
				<div class="col-12 col-lg-4 col-sm-6" data-aos="flip-left">
					<div class="d-flex flex-column rounded-4 p-4 m-1 text-center blog_border" style="background: linear-gradient(90deg, rgba(188,251,255,1) 0%, rgba(223,223,223,1) 100%);">
						<p class="description-md epilogue-semibold">
							Prueba piloto para la reinserción social:
						</p>
						<p class="description-xs epilogue-regular text-center">
							Apoyo a personas recién liberadas mediante oportunidades laborales.
							Trabajo constante con instituciones del sistema penitenciario.
							<br>
							<a class="btn btn-secondary mt-3" href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA" target="_blank"> 
								Mas información
							</a>
						</p>
					</div>
				</div>
				<div class="col-12 col-lg-4 col-sm-6" data-aos="flip-left">
					<div class="d-flex flex-column rounded-4 p-4 m-1 blog_border" style="background: linear-gradient(90deg, rgba(188,251,255,1) 0%, rgba(223,223,223,1) 100%);">
						<p class="description-md epilogue-semibold">
							Caravana Cultural Ambulante:
						</p>
						<p class="description-xs epilogue-regular text-center">
							Actividades educativas y recreativas para niños y familias en bibliotecas públicas.
							Talleres como el de marionetas para fomentar el desarrollo emocional.
							<br>
							<a class="btn btn-secondary mt-3" href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA" target="_blank"> 
								Mas información
							</a>
					    </p>
					</div>
				</div>
				<div class="col-12 col-lg-4 col-sm-6" data-aos="flip-left">
					<div class="d-flex flex-column rounded-4 p-4 m-1 blog_border" style="background: linear-gradient(90deg, rgba(188,251,255,1) 0%, rgba(223,223,223,1) 100%);">
						<p class="description-md epilogue-bold">
							Celebraciones especiales:
						</p>
						<p class="description-xs epilogue-regular text-center">
							Día del Niño en el Varonil Norte: Evento realizado gracias al apoyo de donantes y voluntarios.
							<br>
							<a class="btn btn-secondary mt-3" href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA" target="_blank"> 
								Mas información
							</a>
						</p>

					</div>
				</div>
				<div class="col-12 col-lg-4 col-sm-6" data-aos="flip-left">
					<div class="d-flex flex-column rounded-4 p-4 m-1 blog_border" style="background: linear-gradient(90deg, rgba(188,251,255,1) 0%, rgba(223,223,223,1) 100%);">
						<p class="description-md epilogue-semibold">
							Prueba piloto para la reinserción social:
						</p>
						<p class="description-xs epilogue-regular text-center">
							Apoyo a personas recién liberadas mediante oportunidades laborales.
							Trabajo constante con instituciones del sistema penitenciario.
							<br>
							<a class="btn btn-secondary mt-3" href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA" target="_blank"> 
								Mas información
							</a>
						</p>

					</div>
				</div>
				<div class="col-12 col-lg-4 col-sm-6" data-aos="flip-left">
					<div class="d-flex flex-column rounded-4 p-4 m-1 blog_border" style="background: linear-gradient(90deg, rgba(188,251,255,1) 0%, rgba(223,223,223,1) 100%);">
						<p class="description-md epilogue-semibold">
							Caravana Cultural Ambulante:
						</p>
						<p class="description-xs epilogue-regular text-center">
							Actividades educativas y recreativas para niños y familias en bibliotecas públicas.
							Talleres como el de marionetas para fomentar el desarrollo emocional.
							<br>
							<a class="btn btn-secondary mt-3" href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA" target="_blank"> 
								Mas información
							</a>
					    </p>
					</div>
				</div>
				<div class="col-12 col-lg-4 col-sm-6" data-aos="flip-left">
					<div class="d-flex flex-column rounded-4 p-4 m-1 blog_border" style="background: linear-gradient(90deg, rgba(188,251,255,1) 0%, rgba(223,223,223,1) 100%);">
						<p class="description-md epilogue-bold">
							Celebraciones especiales:
						</p>
						<p class="description-xs epilogue-regular text-center">
							Día del Niño en el Varonil Norte: Evento realizado gracias al apoyo de donantes y voluntarios.
							<br>
							<a class="btn btn-secondary mt-3" href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA" target="_blank"> 
								Mas información
							</a>
						</p>

					</div>
				</div>
			</div> -->
			<div class="row py-4" :style="{'background-image': `url(${bgh})`, backgroundSize: 'cover', backgroundPosition: 'center'}">
				<div class="col-md-6 col-12">
					<div class="d-flex justify-content-evenly align-items-center pt-2 mx-5">
						<img :src="book" class="img-fluid" style="max-height: 250px;" data-aos="flip-left">
					</div>
				</div>
				<div class="col-md-6 col-12 d-flex justify-content-evenly align-items-center" data-aos="flip-left">
					<p class="description-sm epilogue-semibold text-white">
						¡Únete a nuestra causa, <br>
						ayúdanos a seguir promoviendo el cambio!
					</p>
				</div>
				<div class="px-5">
					<div class="bg-dark rounded-4 mx-md-5 mx-2 p-2" style="margin-bottom: -40px;" data-aos="flip-left">
						<Carousel :items-to-show="3" :wrap-around="true" :autoplay="2000" :breakpoints="breakpoints" >
							<Slide v-for="(card, index) in cards_2" :key="index">
								<div class="d-flex align-items-center">
									<div class="bg-primary rounded-circle">
										<img :src="card.image" class="m-3" style="max-width: 40px;">
									</div>
								</div>
								<div class="d-flex flex-column text-white mx-2">
									<p class="m-0 description-xs">
										{{ card.title }}
									</p>
									<p class="m-0 description-xxs">
										{{ card.text }}
									</p>	
								</div>
							</Slide>
						</Carousel>
					</div>
				</div>
			</div>

			<div class="row mt-5">
				<div class="col-12">
					<p class="description-md epilogue-semibold mt-md-5 mt-2">
						Mientras esté allí, eche un vistazo a nuestros últimos artículos
					</p>
					<p class="description-sm epilogue-regular text-primary">
						Consulta nuestro blog
					</p>
				</div>
				<div class="col-12" data-aos="flip-left">
					<Carousel :items-to-show="3" :wrap-around="true" :autoplay="1500" :breakpoints="breakpoints">
						<Slide v-for="(card, index) in cards" :key="index" 
							class="carousel-slide">
							<div class="my-3 text-decoration-none" @click="router.push('/blog');">
								<div class="m-4 bg-white blog_border">
									<img :src="card.image" loading="lazy"
									class="img-fluid"/>
									<p class="text-start description-xxs epilogue-semibold p-0 m-2">{{ card.text }}</p>
								</div>
							</div>
							
						</Slide>
						<template #addons>
						</template>
					</Carousel>
				</div>
			</div>
			<!-- <div class="p-5">
				<div class="position-relative">
					<div class="position-absolute top-50 start-0">
						<img :src="left" class="img-fluid">
					</div>
					<div class="position-absolute top-50 end-0">
						<img :src="right" >
					</div>
					<div class="position-absolute top-50 start-50 translate-middle">
						<img :src="circle" >
					</div>
				</div>
			</div> -->
			<div class="row p-5" data-aos="flip-left">
				<div class="col-12">
					<p class="title-sm epilogue-semibold text-center">Hablemos de...</p>
				</div>
				<div class="col-12 d-flex justify-content-center align-items-center">
					<div class="">
						<img :src="left" class="img-fluid">
					</div>
					<div class="">
						<a class="btn btn-primary px-5 mx-3" href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA" target="_blank">
							<p class="description-sm epilogue-semibold m-0">
								Contacto
							</p>
						</a>
					</div>
					<div class="">
						<img :src="right" class="img-fluid">
					</div>

				</div>
			</div>

			</div>
		</div>

</template>

<script setup>
    import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from "vuex"

    import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'

	import a1 from "ASSETS/images/2"
    import a2 from "ASSETS/images/3"
    import b1 from "ASSETS/images/4"
    import c1 from "ASSETS/images/5"
    import c2 from "ASSETS/images/6"

	import blog1 from "ASSETS/images/blog1"
	import blog2 from "ASSETS/images/blog2"
	import blog3 from "ASSETS/images/blog3"

	import logo1 from "ASSETS/icons/logo1"
	import logo2 from "ASSETS/icons/logo2"
	import logo3 from "ASSETS/icons/logo3"
	import logo4 from "ASSETS/icons/logo4"
	import logo5 from "ASSETS/icons/logo5"

	import book from "ASSETS/images/bookimg"

	import clock from "ASSETS/icons/clock"
	import fingers from "ASSETS/icons/fingers"


	import magdamn from "ASSETS/images/magdamn"
	import magdamn1 from "ASSETS/images/magda1"
	import magdamn2 from "ASSETS/images/magda2"
	import magdamn3 from "ASSETS/images/magda3"
	import magdamn4 from "ASSETS/images/magda4"

	import bgh from "ASSETS/images/backgroundhome"

	import people from "ASSETS/icons/people"
	import check from "ASSETS/icons/check"
	import portafolio from "ASSETS/icons/portfolio"

	import right from "ASSETS/images/vector2"
	import left from "ASSETS/images/vector"
	import circle from "ASSETS/images/highlight"

	import mnbg from "ASSETS/images/vectormn"

	const router = useRouter()

	const cards = [
		{ image: blog1, text: "Entrada de blog 01" },
		{ image: blog2, text: "Entrada de blog 02" },
		{ image: blog3, text: "Entrada de blog 03" }
	]
	const cards_mn = [
    {
        image: logo1,
        title: "Inclusión Social",
        text: "Diseñamos actividades que integran a comunidades marginadas, promoviendo la igualdad y el acceso a oportunidades culturales y educativas.",
    },
    {
        image: logo2,
        title: "Preservación Cultural",
        text: "Nos enfocamos en difundir y preservar las tradiciones mexicanas a través de proyectos artísticos, educativos y gastronómicos que resaltan la riqueza de nuestra cultura.",
    },
    {
        image: logo3,
        title: "Empoderamiento Comunitario",
        text: "Brindamos herramientas y espacios para que las personas desarrollen habilidades, mejoren su calidad de vida y construyan un futuro mejor.",
    },
    {
        image: logo4,
        title: "Reinserción Social",
        text: "Apoyamos a personas que cumplen su condena, proporcionando oportunidades laborales y artísticas para facilitar su reintegración en la sociedad.",
    },
];
	const cards_2 = [
		{ image: people, title: "¿Qué hacemos?", text: "Transformamos vidas a través de arte, cultura y entretenimiento." },
		{ image: portafolio, title: "¿Cómo lo hacemos?",text: "Mediante talleres, eventos y colaboraciones inclusivas." },
		{ image: check, title: "Valores",text: "Cultura y creatividad. Empatía y amor. Altruismo y trabajo colaborativo. Compromiso con el cambio social."  },
	]
	const breakpoints = {  
		200: {
			itemsToShow: 1,
		},    
		576: {
			itemsToShow: 1,
		},
		992: {
			itemsToShow: 3,
		},
	};


</script>



<style lang="scss" scoped>
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.container-1 {
  background-color: #ffffff; /* Fondo claro para contraste */
}

.main-box {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Tres columnas iguales */
  grid-template-rows: 1fr 2fr; /* Dos filas: 1/3 y 2/3 */
  gap: 10px; /* Espaciado entre cuadros */
  width: 80%; /* Tamaño ajustado al contenedor */
  max-width: 900px; /* Limitar el ancho máximo */
  height: 60%; /* Proporción vertical */
  background-color: #e9ecef; /* Fondo principal */
  padding: 10px; /* Espaciado interno */
  border-radius: 8px; /* Bordes redondeados */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Sombra */
}

.box {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #333; /* Fondo oscuro */
  color: #fff; /* Texto blanco */
  text-align: center;
  font-size: 0.9rem;
  border-radius: 5px;
  padding: 10px;
  overflow: hidden; /* Ocultar texto que se desborde */
}

.box.small {
  grid-row: span 1; /* Ocupa 1/3 */
}

.box.large {
  grid-row: span 2; /* Ocupa 2/3 */
}
.column {
  flex: 33.333%;
  max-width: 33.333%;
  padding: 0 4px;
}

.column img {
  margin-top: 8px;
  vertical-align: middle;
  width: 100%;
}

/* Responsive layout - makes a two column-layout instead of four columns */
// @media screen and (max-width: 800px) {
//   .column {
//     flex: 50%;
//     max-width: 50%;
//   }
// }

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    flex: 100%;
    max-width: 100%;
  }
}
</style>
